import { Injectable } from '@angular/core';
import { EventsBlueprint } from './events-blueprint';
import { generateUUID } from "three/src/math/MathUtils.js";
import { ImageProperties } from 'src/app/state/entities/component-properties-dto/images.properties.dto';
import { Store } from '@ngrx/store';
import { EventsWebsocketService } from '../../../services/entities/events-websocket.service';
import { entityActions } from 'src/app/state/entities/entity.actions';
import { CollisionType, Components, EntityType } from 'src/app/state/entities/entity.model';
import { Vector3 } from 'three';
import { reactionEmojis, ReactionProperties } from 'src/app/state/entities/component-properties-dto/reactions.properties.dto';

@Injectable({
  providedIn: 'root'
})
export class OfflineImageService extends EventsBlueprint {

  override prompt = "offlineimages"

  constructor(
    private store: Store,
    private websocketService: EventsWebsocketService,
  ) {
    super()
  }

  override start(): void {
    const id = generateUUID();
    const id2 = generateUUID();
    const id3 = generateUUID();
    const imageIds = [
      "0bccf114-ce98-4c60-a976-da1b5c518bd8",
      "0bccf114-ce98-4c60-a976-da1b5c518bd8",
      "0bccf114-ce98-4c60-a976-da1b5c518bd8",
      "0bccf114-ce98-4c60-a976-da1b5c518bd8",
    ];
    var creationDate = new Date();
    const imageProps: ImageProperties[] = [];
    for (let id of imageIds) {
      imageProps.push({
        fileId: id,
        description: `This is image: ${id}`,
        userDefined: {
          tags: [],
          users: [],
        },
        inferred: { tags: [] },
      });
    }
    this.store.dispatch(
      entityActions.netCreated({
        entity: {
          id: id,
          type: EntityType.Image,
          ownerId: "self",
          components: [Components.text, Components.images, Components.reactions],
          coord: new Vector3(-2, 0, Math.random() * 50),
          componentProperties: {
            Text: "TLDR: Description for an image goes here. Lorem ipsum dolor sit amet. The quick lazy fox jumped over the brown dog.",
            Images: imageProps.slice(0, 1),
            Reactions: this.buildReactions(Math.round(Math.random() * 10)),
          },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(creationDate.getTime()),
        },
      }),
    );
    creationDate.setMinutes(creationDate.getMinutes() - 90);
    this.store.dispatch(
      entityActions.netCreated({
        entity: {
          id: id2,
          type: EntityType.Image,
          ownerId: "self",
          components: [Components.text, Components.images, Components.reactions],
          coord: new Vector3(3, 0, Math.random() * 100),
          componentProperties: {
            Text: "TLDR: Description for an image goes here. Lorem ipsum dolor sit amet. The quick lazy fox jumped over the brown dog.",
            Images: imageProps,
            Reactions: this.buildReactions(Math.round(Math.random() * 10)),
          },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(creationDate.getTime()),
        },
      }),
    );
    creationDate.setDate(creationDate.getDate() - 50);
    this.store.dispatch(
      entityActions.netCreated({
        entity: {
          id: id3,
          type: EntityType.Image,
          ownerId: "self",
          components: [Components.text, Components.images, Components.reactions],
          coord: new Vector3(0, 7, Math.random() * 50),
          componentProperties: {
            Text: "TLDR: Description for an image goes here. Lorem ipsum dolor sit amet. The quick lazy fox jumped over the brown dog.",
            Images: imageProps.slice(0, 3),
            Reactions: this.buildReactions(Math.round(Math.random() * 10)),
          },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(creationDate.getTime()),
        },
      }),
    );
  }

  generateRandomReactionCounters(
    emojis: string[],
    maxCount = 5000,
  ): {[key: string]: number}[] {
    return emojis.slice(0, 4).map((reaction) => ({
      reaction: Math.floor(Math.random() * maxCount), // 0..maxCount-1
    }));
  }

  buildReactions(count: number) {
    const reactionsList = reactionEmojis;
    let reactions: ReactionProperties = {
      smallScaleReactions: [],
      commonReactionsCounters: this.generateRandomReactionCounters(
        reactionsList,
        5000,
      ),
    };
    for (let x = 0; x < count; x++) {
      reactions.smallScaleReactions.push({
        userId: "123",
        reaction:
          reactionsList[Math.round(Math.random() * reactionsList.length - 1)],
      });
    }
    return reactions;
  }
}
